module.exports = __webpack_public_path__ + "common/components/IconDS22/85de4fa353b69918d77565862c434086.svg";